export default __webpack_public_path__ + "static/media/input-by-subcatgory-2.3f91fc1d.svg";